





























import { Component, Vue } from 'vue-property-decorator';
import binaryDownloader from '@/services/BinaryDownloader';

@Component
export default class Home extends Vue {
    public created() {
        this.$store.dispatch('initializeUserProfile', true);
        this.$store.dispatch('material/loadMaterialForms', true);
        this.$store.dispatch('injury/loadInjuryForms', true);
    }

    public sendTo(destination: string): void {
        this.$router.push('reports/' + destination);
    }

    private staffDirectory(): void {
        binaryDownloader('GET', '/api/v1/report/staff_directory');
    }
}
